// Mock data for Lignages de Bruxelles website

export const mockData = {
  // Navigation and site info
  siteTitle: "LES LIGNAGES DE BRUXELLES",
  siteSubtitle: "Héritage et Histoire",
  
  // Languages
  languages: [
    { code: 'fr', name: 'Français', flag: 'FR' },
    { code: 'nl', name: 'Nederlands', flag: 'NL' },
    { code: 'en', name: 'English', flag: 'EN' },
    { code: 'de', name: 'Deutsch', flag: 'DE' }
  ],

  // Hero section
  hero: {
    title: "LES LIGNAGES DE BRUXELLES",
    subtitle: "Les Lignages de Bruxelles, établis dès le XIIIème siècle, ont joué un rôle central dans l'administration et la défense de la ville jusqu'à la fin de l'Ancien Régime.",
    ctaButtons: [
      { text: "L'histoire", href: "#histoire" },
      { text: "Publications", href: "/publications" }
    ]
  },

  // Welcome section
  welcome: {
    title: "Bienvenue sur le site officiel des Lignages de Bruxelles",
    content: `Au nom de l'**Association Royale des Descendants des Lignages de Bruxelles**, je vous souhaite la bienvenue sur notre site.

Les **Lignages de Bruxelles** trouvent leurs origines au cœur du XIIIème siècle. Héritiers d'un patrimoine unique, ils regroupaient les grandes familles patriciennes qui, de génération en génération, ont façonné la vie politique, sociale et judiciaire de la capitale. Ces familles se partageaient les charges publiques et échevinales, participant activement à la gouvernance de la ville jusqu'à la fin de l'Ancien Régime.

Composés de **sept lignages historiques** – Coudenberg, Roodenbeke, Serhuyghs, Serroelofs, Sleeus, Steenweeghs et Sweerts – ces groupes d'ascendance se transmettaient tant par les hommes que par les femmes, incarnant une forme d'élite civique à la fois enracinée dans la ville et ouverte à l'évolution sociale.

Créée en 1961, notre association a pour mission de faire vivre cette mémoire historique à travers des publications, conférences, recherches généalogiques, et une participation active aux **traditions bruxelloises**, notamment au cortège de l'**Ommegang**. Nous nous engageons à transmettre cette histoire fascinante aux générations futures, tout en renforçant les liens entre les descendants des lignages.

Nous vous invitons à découvrir nos archives, nos bulletins, nos événements et les conditions d'adhésion, dans un esprit d'ouverture, de respect des traditions et de mise en valeur du patrimoine bruxellois.

**Bonne visite à toutes et à tous,**`,
    president: {
      name: "Jean-Charles de T'Serclaes",
      title: "Président de l'Association Royale des Descendants des Lignages de Bruxelles",
      patronage: "Sous le haut patronage de Sa Majesté le Roi"
    }
  },

  // Lineages history courses - données réelles
  courses: [
    {
      id: 1,
      title: "Histoire des Lignages",
      description: "Découvrez l'histoire des Lignages de Bruxelles ...",
      duration: "5 minutes",
      image: "/images/courses_1.jpg",
      link: "/lignages"
    },
    {
      id: 2,
      title: "Les prérogatives",
      description: "Les prérogatives des lignages de Bruxelles au XVIIIème siècle ...",
      duration: "4 minutes",
      image: "/images/courses_2.jpg",
      link: "/prerogatives"
    },
    {
      id: 3,
      title: "Jean II de Brabant",
      description: "Traduction de la Charte Jean II de Brabant (12 juin 1306) ...",
      duration: "6 minutes",
      image: "/images/courses_3.jpg",
      link: "/jean-ii-brabant"
    },
    {
      id: 4,
      title: "Les Familles et blasons",
      description: "Familles descendantes des sept lignages ...",
      duration: "Plus de 600 familles",
      image: "/images/courses_4.jpg",
      link: "/familles-blasons"
    }
  ],

  // Events - données réelles
  events: [
    {
      id: 1,
      date: "05 octobre 2025",
      title: "Convocation à l'assemblée Générale des Lignages",
      description: "Le Président vous convie à l'assemblée générale ordinaire de l'Association Royale des Descendants des Lignages de Bruxelles, qui se tiendra le je ...",
      image: "/images/placeholder-event.jpg", // Mock data - remplacer par vraie image
      type: "assembly"
    },
    {
      id: 2,
      date: "06 décembre 2025",
      title: "Rencontre des membres et familles.",
      description: "👨‍👩‍👧‍👦 Rencontre des membres et des familles des Lignages de Bruxelles. Chers membres, chers amis, Et si on prenait le temps de se r ...",
      image: "/images/placeholder-event.jpg", // Mock data - remplacer par vraie image
      type: "community"
    },
    {
      id: 3,
      date: "10 novembre 2025",
      title: "Visite à Manneken-Pis",
      description: "Cette année, le 12 juin notre Manneken Pis national revêtira l'habit traditionnel de Bourgmestre des Lignages de Bruxelles. Il en sera vêtu toute ...",
      image: "/images/placeholder-event.jpg", // Mock data - remplacer par vraie image
      type: "cultural"
    }
  ],

  // Statistics - données exactes du site français original
  statistics: [
    {
      number: "7",
      label: "lignages",
      icon: "/images/chart-icon_lignages.png"
    },
    {
      number: "755",
      label: "Membres",
      icon: "/images/chart-icon_members.png"
    },
    {
      number: "66",
      label: "Bulletins publiés",
      icon: "/images/chart-icon_bulletins.png"
    },
    {
      number: "719",
      label: "Ans d'histoire",
      icon: "/images/chart-icon_annees.png"
    }
  ],

  // News - données réelles
  news: [
    {
      id: 1,
      title: "L'Ommegang 2025 : une édition éclatante au cœur de Bruxelles",
      author: "admin",
      date: "06-Jul-2025",
      image: "/images/placeholder-news.jpg", // Mock data - remplacer par vraie image
      excerpt: "Découvrez les moments forts de l'Ommegang 2025, une célébration exceptionnelle des traditions bruxelloises..."
    },
    {
      id: 2,
      title: "Nouveau site web",
      author: "admin",
      date: "06-Jul-2025",
      image: "/images/placeholder-news.jpg", // Mock data - remplacer par vraie image
      excerpt: "Nous sommes fiers de vous présenter notre nouveau site web, entièrement repensé pour mieux servir nos membres..."
    }
  ],

  // Navigation menu - matches the original HTML structure
  navigation: {
    left: [
      { type: 'home', href: "/", icon: 'home' },
      { 
        type: 'dropdown', 
        title: 'Histoire des Lignages',
        items: [
          { title: 'Histoire des Lignages', href: '/lignages' },
          { title: 'Les prérogatives', href: '/prerogatives' },
          { title: 'Jean II de Brabant', href: '/jean-ii-brabant' },
          { title: 'Les Familles et blasons', href: '/blasons' }
        ]
      },
      { 
        type: 'dropdown', 
        title: 'Actualité',
        items: [
          { title: 'Les News', href: '/#news' },
          { title: 'Événements à venir', href: '/#event' }
        ]
      }
    ],
    right: [
      { 
        type: 'dropdown', 
        title: 'Association',
        items: [
          { title: 'Constitution et But', href: '/but' },
          { title: 'Conseil', href: '/conseil' },
          { title: 'Devenir membres', href: '/admission' }
        ]
      },
      { 
        type: 'dropdown', 
        title: 'Publications',
        items: [
          { title: 'Le Bulletin', href: '/publications?type=Le%20Bulletin' },
          { title: 'Le Valet', href: '/publications?type=Le%20Valet' },
          { title: 'Les filiations lignagères', href: '/publications?type=Les%20filiations%20lignagères' },
          { title: 'Vade-mecum', href: '/publications?type=Vade-mecum' }
        ]
      },
      { type: 'link', title: 'Contact', href: '/contact' }
    ]
  },

  // Seven Lineages
  sevenLineages: [
    "Coudenberg",
    "Roodenbeke", 
    "Serhuyghs",
    "Serroelofs",
    "Sleeus",
    "Steenweeghs",
    "Sweerts"
  ]
};

export default mockData;